import type { GridOptions } from 'ag-grid-community';

import { COLUMN_MENU_GRID_OPTIONS } from '@/components/AgGrid/helpers/columnMenu';

// Options every app grid sets the same way: the app's thin scrollbars, tooltips only over truncated text,
// shown at once, no row or column animations, and the one column menu (pin button menu, pencil → column
// chooser, no right-click menu).
export const BASE_GRID_OPTIONS = {
  ...COLUMN_MENU_GRID_OPTIONS,
  animateRows: false, // row animations can be a performance bottleneck
  suppressMoveWhenColumnDragging: true,
  tooltipShowMode: 'whenTruncated',
  tooltipShowDelay: 0,
  scrollbarWidth: 8,
  alwaysShowHorizontalScroll: true,
} as const satisfies GridOptions;
